<template>
  <div class="max-w-3xl">
    <form @submit.prevent="submit">
      <TextInput label="Text Label" v-model="form.label"></TextInput>

      <SelectInput label="Preset" v-model="form.preset" class="mt-8">
        <option value="red">Red</option>
        <option value="blue">Blue</option>
        <option value="green">Green</option>
        <option value="yellow">Yellow</option>
        <option value="yellowish">Warmish</option>
        <option value="greenish">Greenish</option>
        <option value="blueish">Blueish</option>
      </SelectInput>

      <div class="mt-2 flex flex-col mt-8">
        <div v-if="form.preset">
          <div class="py-2"><small>Preview</small></div>
          <span class="rounded py-1 px-2 font-bold" :class="presets[form.preset]">{{ form.label }}</span>
        </div>
      </div>

      <div class="mt-2 flex flex-col mt-8">
        <div>
          <SelectInput label="Publish" v-model="form.publish" class="mt-8">
            <option :value="true">Yes</option>
            <option :value="false">No</option>
          </SelectInput>
        </div>
      </div>

      <div class="mt-8">
          <span class="inline-flex rounded-md shadow-sm">
            <button type="button" @click="submit" class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-indigo active:bg-indigo-700 transition ease-in-out duration-150">
              <span v-if="processing">...please wait</span>
              <span v-else>Submit</span>
            </button>
          </span>
      </div>
    </form>
  </div>
</template>

<script>
import TextInput from '../../../../Shared/TextInput'
import SelectInput from '../../../../Shared/SelectInput'


export default {
  name: 'Form',
  components: {SelectInput, TextInput},
  props: {
    labelInput: String,
    presetInput: String,
    publishInput: Boolean,
    processing: Boolean,
    presets: Object
  },
  data() {
    return {
      form: {
        label: this.labelInput || null,
        preset: this.presetInput || null,
        publish: this.publishInput || null,
      }
    }
  },

  methods: {
    submit() {
      this.$emit('submit', this.form)
    }
  }



}
</script>
